<script>
import Splash from "@/components/Splash/Splash.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import ProductsAdjustmentCoefficients from "@/components/Financial_management_and_productivity/DefineAdjustmentCoefficients/ProductsAdjustmentCoefficients";

export default {
  components: {Sidebar, Splash, ProductsAdjustmentCoefficients}
}
</script>

<template>
  <splash/>
  <div class="container mt-4" dir="rtl">
    <sidebar/>
    <div class="card-panel-main col-lg-9 mb-5 p-4">

      <div class="card bg-white">
        <div class="d-flex m-3 justify-content-between border-bottom border-2">
          <p class="fw-bold">
            ضرایب تعدیل محصولات
          </p>
        </div>

        <ProductsAdjustmentCoefficients/>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card-panel-main {
  transform: translateX(-19vw);
}
</style>
